import { render } from "./RegionZhambylObl.vue?vue&type=template&id=3d3aa73e&ts=true"
import script from "./RegionZhambylObl.vue?vue&type=script&lang=ts"
export * from "./RegionZhambylObl.vue?vue&type=script&lang=ts"

import "./RegionZhambylObl.vue?vue&type=style&index=0&id=3d3aa73e&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__